<div *ngIf="apiLoaded | async">
  <google-map
    #map
    [options]="options"
    [center]="center"
    [zoom]="zoom"
    width="100%"
    height="100%"
    class="map"
    [ngClass]="{'-loading': mapLoading}"
    (zoomChanged)="zoomChanged()"
  >
    <map-marker-clusterer [imagePath]="markerClustererImagePath">
    <map-marker #somemarker="mapMarker" *ngFor="let pos of poses$  | async; let i = index" (mapClick)="openInfoWindow(somemarker, i)" [position]="{lat: pos.latitude, lng: pos.longitude}" [options]="{icon: markerIcon}">
      <map-info-window [width]="500" [maxHeight]="300" [closeWhenOthersOpen]="true">
          <div class="m-pos">
            <div class="m-pos__name">{{pos.displayName}}</div>
            <div class="m-pos__row">
              <div class="m-pos__col">
                <address class="m-pos__address">
                  {{pos?.address?.street}}
                  <br>{{pos?.address?.postalCode}} {{pos?.address?.town}}
                </address>
                <div class="m-pos__tel">{{pos?.address?.phone}}</div>
                <div class="m-pos__email"><a href="mailto: {{pos?.address?.mail}}">{{pos?.address?.mail}}</a></div>
              </div>
              <div class="m-pos__col">
                <ul class="m-pos__open-hours">
                  <li *ngFor="let day of pos.openingHours">{{day}}</li>
                </ul>
                <div class="m-pos__button">
                  <a href="{{pos.appoitmentUrl}}">{{'map.pos.button.text' | translate }}</a>
                </div>
              </div>
            </div>
          </div>
      </map-info-window>
    </map-marker>
    </map-marker-clusterer>
  </google-map>
</div>
